import moment from "moment";
import { SignUpStatus } from "../../features/auth/presentation/signup_wizard/vuex/SignupWizard.store";
import {
  SET_AUTHSTATE,
  SET_TOKEN,
  SET_USER,
  SET_AUTH_STATUS,
  SET_RELATIVE_READY,
  UPDATE_INVOICE_REQUIRED,
  SET_EXPTOKEN,
  SET_CAMPUS,
  CLEAR_TOKEN,
} from "./../mutation-types";

export const AuthStatus = {
  idle: "idle",
  authenticated: "authenticated",
  unauthenticated: "unauthenticated",
};

const token = localStorage.getItem("token");
const expiresIn = localStorage.getItem("expiresIn")
  ? moment(localStorage.getItem("expiresIn"))
  : null;

const User = {
  namespaced: true,

  state: {
    token,
    expiresIn,
    name: "",
    lastname: "",
    uuid: "",
    type: "",
    parentUuid: "",
    campus: "",
    applicationOptions: [],
    idInt: 0,
    country: "",
    picture: "",
    isAuth: false,
    userName: "",
    isTi: false,
    relative: null,

    authStatus: AuthStatus.idle,
  },

  mutations: {
    [SET_EXPTOKEN](state, expToken) {
      state.expToken = expToken;
    },
    [SET_TOKEN](state, { token, expiresIn }) {
      const expirationDate = moment().add(expiresIn, "seconds");
      state.token = token;
      state.expiresIn = expirationDate;
      localStorage.setItem("token", token);
      localStorage.setItem("expiresIn", expirationDate);
    },
    [SET_USER](state, user) {
      (state.name = user.name), (state.lastname = user.lastname);
      state.firstsurname = user.firstsurname;
      state.uuid = user.uuid;
      state.idInt = user.idInt;
      state.type = user.type;
      state.campus = user.campus;
      state.country = user.country;
      state.applicationOptions = user.applicationOptions;
      state.picture = user.picture;
      state.userName = user.userName;
      state.isTi = user.isTi;
      state.relative = user.relative;
      state.authStatus = AuthStatus.authenticated;
    },
    [SET_AUTHSTATE](state, auth) {
      state.isAuth = auth;
    },
    [SET_AUTH_STATUS](state, status) {
      state.authStatus = status;
    },
    [SET_RELATIVE_READY](state) {
      state.relative.signUpStatus = SignUpStatus.CHILDREN_READY;
    },
    [UPDATE_INVOICE_REQUIRED](state, invoiceRequired) {
      state.relative.invoiceRequired = invoiceRequired;
    },
    [SET_CAMPUS](state, campusId) {
      state.campus = campusId;
    },
    [CLEAR_TOKEN](state) {
      state.token = null;
      state.expiresIn = null;
      localStorage.clear("token");
      localStorage.clear("expiresIn");
    },
  },

  actions: {
    setExpToken({ commit }, expToken) {
      commit(SET_EXPTOKEN, expToken);
    },
    setToken({ commit }, data) {
      commit(SET_TOKEN, data);
    },
    async loadUser(
      { commit, rootState, dispatch, state },
      forceUpdate = false
    ) {
      try {
        if (state.authStatus == AuthStatus.authenticated && !forceUpdate) {
          await dispatch("setCampus", null, { root: true });
          await dispatch("setPeriods", null, { root: true });
          return;
        }

        const { data: userOptions } = await rootState.api.util.getUserOptions();
        const user = {
          name: userOptions.firstName,
          lastname: userOptions.secondName,
          firstsurname: userOptions.firstSurname,
          uuid: userOptions.idUser,
          type: userOptions.idUserType,
          campus: userOptions.idCampus,
          applicationOptions: userOptions.applicationOptions,
          idInt: userOptions.idUserInt,
          country: userOptions.country,
          picture: userOptions.picture,
          userName: userOptions.userName,
          isTi: userOptions.isTI,
          relative: userOptions.relative,
        };
        commit(SET_USER, user);
        dispatch("setCampus", null, { root: true });
        dispatch("setPeriods", null, { root: true });
      } catch (err) {
        commit(SET_AUTH_STATUS, AuthStatus.unauthenticated);
      }
    },
    setAuthState({ commit }, auth) {
      commit(SET_AUTHSTATE, auth);
    },
    setCampus({ commit }, campusId) {
      commit(SET_CAMPUS, campusId);
    },
    async logout({ commit }) {
      commit(SET_AUTH_STATUS, AuthStatus.unauthenticated);
      commit(CLEAR_TOKEN);
    },
    relativeReady({ commit }) {
      commit(SET_RELATIVE_READY);
    },
    updateInvoiceRequired({ commit }, invoiceRequired) {
      commit(UPDATE_INVOICE_REQUIRED, invoiceRequired);
    },
  },
  getters: {
    isLoggedIn: (state) => {
      const { token, expiresIn } = state;

      if (!token || !expiresIn) {
        return false;
      }

      const now = moment();
      const isValid = now.isBefore(expiresIn);

      return isValid && token != "";
    },
    token: (state) => {
      return "bearer " + state.token;
    },
    accessLevel: (state, _, rootState) => {
      return rootState.Catalogs.userRoles
        .map((c) => {
          return c.id;
        })
        .indexOf(state.type);
    },
    isGuest: (state) => {
      return state.type === "e5ad5b4b-4878-11e6-8f8d-686ce32e3eaa";
    },
    isStudent: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[0].id;
    },
    isCoach: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[1].id;
    },
    isCoord: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[2].id;
    },
    isAdmin: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[3].id;
    },
    isCallCenter: (state, _, rootState) => {
      return [
        rootState.Catalogs.userRoles[6].id,
        rootState.Catalogs.userRoles[7].id,
        rootState.Catalogs.userRoles[8].id,
      ].includes(state.type);
    },
    isKnCom: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[4].id;
    },
    isKnComAdmin: (state, _, rootState) => {
      return state.type === rootState.Catalogs.userRoles[5].id;
    },
    isRelative: (state, getters, rootState) => {
      return state.type === rootState.Catalogs.userRoles[9].id;
    },
    name: (state) => {
      return {
        name: state.name,
        lastname: state.lastname,
        firstsurname: state.firstsurname,
      };
    },
    avaliablesPaths(state) {
      var urls = [];
      try {
        const childs = [].concat.apply(
          [],
          state.applicationOptions.map((o) => o.childs)
        );
        urls = state.applicationOptions
          .concat(childs)
          .map((o) => o.url)
          .filter((u) => u != "#")
          .sort();
      } catch (error) {
        //TODO: Show error
      }
      return urls;
    },
    campus: (state) => {
      return state.campus;
    },
    signUpStatus(state) {
      if (state.relative) {
        return state.relative.signUpStatus;
      }

      return SignUpStatus.CHILDREN_READY;
    },
  },
};

export default User;
